var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitedStatesOfAmerica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "united-states-of-america",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.931,
    height: 26.487,
    viewBox: "0 0 36.931 26.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9307",
    "data-name": "Path 9307",
    d: "M0,85.331H36.931v26.487H0Z",
    transform: "translate(0 -85.331)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9308",
    "data-name": "Path 9308",
    d: "M0,127.994H36.931V131.3H0Zm0,6.622H36.931v3.311H0Zm0,6.621H36.931v3.311H0Zm0,6.622H36.931v3.311H0Z",
    transform: "translate(0 -124.683)",
    fill: "#d80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9309",
    "data-name": "Path 9309",
    d: "M0,85.331H21.024V99.593H0Z",
    transform: "translate(0 -85.331)",
    fill: "#2e52b2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9310",
    "data-name": "Path 9310",
    d: "M32.064,118.4l-.339.984h-1.1l.886.608-.339.984.886-.608.886.608-.339-.984.886-.608H32.4Zm.338,4.536-.338-.984-.339.984h-1.1l.886.608-.339.984.886-.608.886.608-.339-.984.886-.608Zm-4.629,0-.338-.984-.339.984H26l.886.608-.339.984.886-.608.886.608-.339-.984.886-.608Zm-.338-4.536-.339.984H26l.886.608-.339.984.886-.608.886.608-.339-.984.886-.608h-1.1Zm4.629-3.552-.339.984h-1.1l.886.608-.339.984.886-.608.886.608-.339-.984.886-.608H32.4Zm-4.629,0-.339.984H26l.886.608-.339.984.886-.608.886.608-.339-.984.886-.608h-1.1Zm9.258,3.552-.339.984h-1.1l.886.608-.338.984.886-.608.886.608-.339-.984.886-.608h-1.1Zm.338,4.536-.338-.984-.339.984h-1.1l.886.608-.338.984.886-.608.886.608-.339-.984.886-.608Zm4.629,0-.338-.984-.339.984h-1.1l.886.608-.339.984.886-.608.886.608-.339-.984.886-.608Zm-.338-4.536-.339.984h-1.1l.886.608-.339.984.886-.608.886.608-.339-.984.886-.608h-1.1Zm-4.629-3.552-.339.984h-1.1l.886.608-.338.984.886-.608.886.608-.339-.984.886-.608h-1.1Zm4.629,0-.339.984h-1.1l.886.608-.339.984.886-.608.886.608-.339-.984.886-.608h-1.1Z",
    transform: "translate(-23.866 -112.559)",
    fill: "#f0f0f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedStatesOfAmerica);
export default __webpack_public_path__ + "static/media/united-states-of-america.f8920252d076b10e94346b377ad8f746.svg";
export { ForwardRef as ReactComponent };